import { getEnv } from "@ace/env";

export type FundMeta = {
  archaxAccessFeePercentage: string;
  archaxRedemptionCutoffTime: string;
  archaxSubscriptionCutoffTime: string;
  fundManagementFeePercentage: string;
  fundRedemptionCutoffTime: string;
  fundSubscriptionCutoffTime: string;
  isin: string;
  lei: string;
  maximumOrderValue: string;
  minimumOrderValue: string;
  objective: string;
  sector: string;
  sedol: string;
  shareClass: string;
  valoren: string;
};

export type FundStatus = "Coming Soon" | "Subscribe" | "Closed";

export type Fund = {
  id: number;
  name: string;
  price: string;
  status: FundStatus;
  tradingPairId: number;
  type: string;
  meta: FundMeta;
};

export const getFunds = async (): Promise<Fund[]> => {
  const response = await fetch(
    `${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/rest-gateway/invest/investment`,
    {
      method: "GET",
    },
  );
  const json = await response.json();

  if (json.status === "ERROR") {
    throw new Error(json.error[0].msg);
  }

  const data = json.data as Fund[];

  return data;
};
